import HandledByCell from './container';

export default HandledByCell;
